import AppHeader from './Header/Header.vue';

export default {
    name: 'Header',
    components: {
        AppHeader,
    },
};
